import { theme } from '@features/lci-report/domain/theme';
import { TextProps } from '@features/powerpoint';
import { sharedCaptionCoords } from './layout';

export const headerWithCaption = (
  header: string,
  caption: string,
  options: TextProps['options'] = {}
): TextProps => ({
  text: [
    {
      text: header.toUpperCase(),
      options: {
        bold: true,
        color: theme.colors.inmarketGreen,
        breakLine: true,
      },
    },
    {
      text: caption,
      options: {
        color: theme.colors.white,
      },
    },
  ],
  options: {
    fontSize: 14,
    align: 'center',
    paraSpaceBefore: 9,
    valign: 'top',
    ...sharedCaptionCoords,
    ...options,
  },
});
